import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { PpmRepository } from '../../../../store/ppm-state/ppm-state.repository';

interface getPpmVersionHistoryDataTableStructureProps {
  store: PpmRepository;
  rowActions?: DataTableRowActions;
}

export const getPpmVersionHistoryDataTableStructure = ({ store, rowActions }: getPpmVersionHistoryDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.name',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const versionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.version',
    accessorKey: 'version',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const anneeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const budgetColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.budget',
    accessorKey: 'budgetEstime',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      if (value) {
        return { value: value };
      }
      return { value: 'Non défini', class: 'opacity-70' };
    },
  };

  const refreshedColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.refreshed',
    accessorKey: 'actualise',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: value ? 'Oui' : 'Non', class: 'text-xs' };
    },
    props: {
      getSeverity: (value: boolean) => {
        if (value) return 'success';
        return 'danger';
      },
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'ppm.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `ppm.status.${value}` };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.updated_at',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const acColumnn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  // const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ppm.table.created_by',
  //   accessorKey: 'metadata.createdBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  // const updatedByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ppm.table.updated_by',
  //   accessorKey: 'metadata.updatedBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  return {
    singular: 'Historique des Plans de Passation des Marchés',
    plural: 'Historiques des Plans de Passation des Marchés',
    data: [],
    columns: [
      versionColumn,
      refColumn,
      anneeColumn,
      acColumnn,
      refreshedColumn,
      statusColumn,
      processStepColumn,
      budgetColumn,
      createdAtColumn,
      updatedAtColumn,
    ],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.setNested('response', row);
    },
    rowActions,
    searchableFields: ['ref', 'annee', 'status'],
  };
};
